import React, { useContext, useEffect, useState } from "react";

import { CircularProgress, Grid, Grow } from "@material-ui/core";

import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import AlarmAddIcon from "@material-ui/icons/AlarmAdd";

import Card from "../../../../components/cards/Card";
import { Text, TimelineIcon } from "../styles/Emissao";

import { PainelNfeContext } from "../contexts/PainelNfeContext";
import useNfeController from "../controllers/NfeController";

const TabCCHistorico = ({ nfeId }) => {
  const { handleHistoryCC } = useNfeController();
  const [viewLoading, setViewLoading] = useState(false);

  const { historyCC, setHistoryCC } = useContext(PainelNfeContext);

  useEffect(() => {
    (async () => {
      const callbackHistoryCC = await handleHistoryCC(nfeId, setViewLoading);
      setHistoryCC(callbackHistoryCC);
    })();
    // eslint-disable-next-line
  }, [nfeId]);

  return (
    <Grow in={true}>
      <Timeline align="alternate">
        {viewLoading && (
          <Grid container justifyContent="center" alignItems="center">
            <CircularProgress />
          </Grid>
        )}
        {historyCC.length && !viewLoading ? (
          historyCC.map((cc, key) => (
            <TimelineItem key={`timelineKey_${key}`}>
              <TimelineOppositeContent>
                <Text>{cc.updated_at}</Text>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineIcon>
                  <AlarmAddIcon />
                </TimelineIcon>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Card line="left" lineColor="primary">
                  <Text>{cc.nprot || "Sem Protocolo"}</Text>
                  <Text>{cc.descricao}</Text>
                </Card>
              </TimelineContent>
            </TimelineItem>
          ))
        ) : (
          <> </>
        )}
      </Timeline>
    </Grow>
  );
};

export default TabCCHistorico;
